// stepsData.ts
import VerifyConsentForm from "../pages/eligibility-check/VerifyConsentForm";
import CourseDetailsForm from "../pages/eligibility-check/CourseDetailsForm";
import LoanDetailsForm from "../pages/eligibility-check/LoanDetailsForm";
import EligibilityConfirmation from "../pages/eligibility-check/EligibilityConfirmation";
import StudentDetails from "../pages/student-details/StudentDetails";
import AddressDetails from "../pages/student-details/AddressDetails";
import EmploymentDetails from "../pages/student-details/EmploymentDetails";
import EntranceExamDetails from "../pages/student-details/EntranceExamDetails";
import LoanDetails from "../pages/student-details/LoanDetails";
import AcademicDetails from "../pages/student-details/AcademicDetails";
import Summary from "../pages/provisional-offer/ProvisionalOfferPage";
export interface StepConfig {
  label: string;
  FormComponent: React.ComponentType<{
    onNext: () => void;
    firstName: string;
    provisionalOffer: any;
  }>;
}

export const eligibilitysteps: StepConfig[] = [
  {
    label: "Verify Yourself and Provide Consent hhh",
    FormComponent: VerifyConsentForm,
  },
  { label: "Provide Course Details", FormComponent: CourseDetailsForm },
  { label: "Provide Loan Details", FormComponent: LoanDetailsForm },
  {
    label: "Confirmation on Eligibility",
    FormComponent: EligibilityConfirmation,
  },
];
export const studentInfoSteps: StepConfig[] = [
  { label: "Student Details", FormComponent: StudentDetails },
  { label: "Address Details", FormComponent: AddressDetails },
  { label: "Employment Details", FormComponent: EmploymentDetails },
  { label: "Academic Details", FormComponent: AcademicDetails },
  { label: "Entrance Exam Details", FormComponent: EntranceExamDetails },
  { label: "Loan Details", FormComponent: LoanDetails },
];
export const topCountry: any = [
  'UNITED STATES OF AMERICA',
  'UNITED KINGDOM',
  'CANADA',
  'AUSTRALIA',
  'GERMANY',
  'IRELAND',
  'FRANCE',
  'NEWZEALAND'
];
export const summarySteps: StepConfig[] = [];